import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=0c146f38&scoped=true&lang=pug"
import script from "./AppLoading.vue?vue&type=script&lang=ts"
export * from "./AppLoading.vue?vue&type=script&lang=ts"
import style0 from "./AppLoading.vue?vue&type=style&index=0&id=0c146f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c146f38",
  null
  
)

export default component.exports